import React from 'react'
import "./AllNewPackages.css";
import { useState } from 'react';
// const { state } = PackActive;
// const [ActivePack,setActivePack] = useState(state)

export default function PackageName({value, activePackage,state}) {

    // const [activePackage, setactivePackage] = useState(false)
    // const handleActive = ()=>{
    //   if(activePackage){
    //     setactivePackage(false)
    //   }
    //   setactivePackage(!activePackage)  
    // }
    return (      
      <span className={( activePackage === value) ? "packageSpan fontColoR" : "packageSpan"} > {value} Packages</span>  
    )
}
